module.exports = __webpack_public_path__ + "media/images/lb/980-160d53e1e282c5f596f48e07f346ac44.svg";